import {
  OperationSummaryError,
  OperationSummaryParams
} from 'components/RecordsListView/types';
import useOperationSummary from 'hooks/useOperationSummary';
import useWorkOrders, { WorkOrderSummary } from './useWorkOrders';

interface UseWorkOrdersSummaryReturn {
  loading: boolean;
  workOrders: WorkOrderSummary[];
  totalElements: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  numberOfElements: number;
  loadWorkOrders: () => Promise<void>;
  errors?: OperationSummaryError | null;
  /** Crop seasons the held rows were fetched for; undefined until the first response. */
  loadedCropSeasonIds?: string[];
}

const useWorkOrdersSummary = (
  params?: OperationSummaryParams
): UseWorkOrdersSummaryReturn => {
  const { getSummaryWorkOrders } = useWorkOrders();

  const {
    loading,
    items: workOrders,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadItems: loadWorkOrders,
    errors,
    loadedCropSeasonIds
  } = useOperationSummary<WorkOrderSummary>(
    'workOrdersSummary',
    getSummaryWorkOrders,
    params,
    'workOrdersSummary'
  );

  return {
    loading,
    workOrders,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadWorkOrders,
    errors,
    loadedCropSeasonIds
  };
};

export default useWorkOrdersSummary;
